/*
 * @param {Object} data Object containing first and last name
 * @returns {String} The full name or partial name
 */
export default function(data) {
  if (data) {
    if (data.first_name && data.last_name) {
      return `${data.first_name} ${data.last_name}`;
    } else if (data.first_name && !data.last_name) {
      return `${data.first_name}`;
    } else if (!data.first_name && data.last_name) {
      return `${data.last_name}`;
    }
    return '';
  }
  return '';
}
